import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-selection-modal',
  templateUrl: 'selection-modal.html',
})
export class SelectionModalPage {

  data: any;
  category: string

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private visitor: VisitorProvider,
    private viewCtrl: ViewController) {
      let data = this.navParams.get('data'); //optional
      this.category = this.navParams.get('category');
      if(!data){
        this.visitor.getCompaniesByCategory(this.category).then(val => {
          if(val.status == "success"){
            this.data = val.data;
            this.setFileName();
          }
        });
      }else{
        this.data = data;
        this.setFileName();
      }
  }

  dismiss() {
    this.viewCtrl.dismiss("");
  }

  setFileName(){
    this.data.forEach(item => {
      if(item.icon && item.icon != ""){
        item.fileName = item.icon.slice(item.icon.lastIndexOf('/'));
      }else{
        item.fileName = "default.png";
      }
    });
  }

  onSelect(item){
    this.viewCtrl.dismiss(item.name);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectionModalPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/selection-modal/selection-modal.ts